import { render, staticRenderFns } from "./DataGridBody.vue?vue&type=template&id=7b2491da&scoped=true&"
import script from "./DataGridBody.vue?vue&type=script&lang=js&"
export * from "./DataGridBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2491da",
  null
  
)

export default component.exports